export default __webpack_public_path__ + "static/media/calendar.3b9dda43.svg";